import SectionTitle from './SectionTitle';
export default function DocumentSection({ title, children, variant, className = '' }) { if (!children) return null; return <section className={`document-section document-avoid-break ${className}`}><SectionTitle variant={variant}>{title}</SectionTitle>{children}</section>; }
